import { useState } from 'react'
import { IconButton } from '@/shared/components/IconButton'
import { CopyIcon, CheckIcon } from '@/shared/components/Icons'

export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false)
  return (
    <IconButton
      label="Copy value"
      tip={copied ? 'Copied' : 'Copy value'}
      onClick={() => {
        navigator.clipboard?.writeText(text).then(() => { setCopied(true); setTimeout(() => setCopied(false), 1200) }).catch(() => {})
      }}
    >
      {copied ? <CheckIcon /> : <CopyIcon />}
    </IconButton>
  )
}

